module.exports = __webpack_public_path__ + "../static/img/herbarium-logo.4580e25b.png";